import { MTFiltersValuesI } from "@services/getMinerList";
import { ActionSetCurrentFilters } from "./actionTypes";

export const setFilter = (
  filter: keyof MTFiltersValuesI,
  value: ActionSetCurrentFilters["payload"],
  values: MTFiltersValuesI
): MTFiltersValuesI => {
  return { ...values, [filter]: value };
};
